export const getInitials = (name: string) => {
	return name
		.split(" ")
		.filter((_, index) => index < 2)
		.map((n) => n[0])
		.join("");
};
